import { PeriodMode } from '../../../../enums/periodMode'

export const headerPeriodModes: PeriodMode[] = [
  PeriodMode.Month,
  PeriodMode.Quarter,
  PeriodMode.FiscalYear,
  PeriodMode.All,
]
